export const RESULT_REASON_CONFIG = {
  budget: {
    budget_low: {
      title: '예산 기준',
      description:
        '예산 효율을 중요하게 생각하셔서 기성복 또는 반수제 중심으로 분석했어요.',
      icon: 'ri-wallet-3-line',
    },

    budget_mid: {
      title: '예산 기준',
      description:
        '100~200만원대는 반수제를 가장 안정적으로 선택할 수 있는 구간이에요.',
      icon: 'ri-wallet-3-line',
    },

    budget_high: {
      title: '예산 기준',
      description:
        '완성도와 체형 보정을 충분히 고려할 수 있는 예산대로 분석했어요.',
      icon: 'ri-wallet-3-line',
    },
  },

  bodyType: {
    body_muscular: {
      title: '체형 기준',
      description:
        '운동 체형은 기성복보다 반수제 이상의 체형 보정 만족도가 높은 편이에요.',
      icon: 'ri-user-3-line',
    },

    body_slim: {
      title: '체형 기준',
      description:
        '마른 체형은 어깨/가슴 핏 보정이 중요해서 반수제 만족도가 높아지는 경우가 많아요.',
      icon: 'ri-user-3-line',
    },
  },

  usage: {
    usage_often: {
      title: '활용도 기준',
      description:
        '결혼 이후에도 정장을 자주 입을 예정이라 활용성과 핏 완성도를 중요하게 봤어요.',
      icon: 'ri-suitcase-line',
    },
  },

  schedule: {
    schedule_short: {
      title: '일정 기준',
      description:
        '예식 일정이 가까운 편이라 제작 안정성과 일정 대응력을 함께 고려했어요.',
      icon: 'ri-time-line',
    },
  },
};